import React from 'react';
import { applyTimeZone } from '../../../../utils/utils';
import { getCastellerShortName } from '../../../../utils/castellerName';

function Box({ 
    isClone,
    isPom,
    pomType,
    empty,
    lastPair,
    bundleJSON,
    assistencia,
    hores,
    sumaAltures,
    selectBox,
    caixa,
    selectedBox,
    casteller,
    castellersInfo 
}) {
    if (empty) {
        return (
            <div className="box empty">
                <style jsx>{`
                    .box.empty {
                        width: 65px;
                        height: 25px;
                        padding: 3px 0;
                        background: transparent;
                        margin: 3px;
                        position: relative;
                    }
                `}</style>
            </div>
        );
    }

    const displayName = casteller => {
        if (casteller === null || casteller === undefined) return '';
        if (!(casteller in castellersInfo)) return 'ELIMINAT';

        return getCastellerShortName(castellersInfo[casteller]);
    };

    const momEntrada = assistencia?.['data-entrada'] ? applyTimeZone(assistencia?.['data-entrada']) : null;
    const horaEntrada = momEntrada?.isValid() && momEntrada.format('HH:mm');
    const arribaTard = momEntrada?.isValid() && horaEntrada > hores?.[0];

    const momSortida = assistencia?.['data-sortida'] ? applyTimeZone(assistencia?.['data-sortida']) : null;
    const horaSortida = momSortida?.isValid() && momSortida.format('HH:mm');
    const surtAviat = momSortida?.isValid() && horaSortida < hores?.[1];

    const assistenciaColor = (() => {
        if (!casteller || !(casteller in castellersInfo)) {
            return '#ccc';  // No casteller assigned
        }

        // Handle numeric assistència values
        const assistenciaValue = assistencia?.['assistència'];
        
        if (arribaTard || surtAviat) return 'rgba(255,0,0,0.2)';
        if (assistenciaValue === 2) return 'rgba(0,0,255,0.2)';  // Fitxat
        if (assistenciaValue === 1) return 'rgba(0,255,0,0.2)';  // Vinc
        if (assistenciaValue === 0) return 'rgba(255,0,0,0.2)';  // No vinc
        return 'rgba(255,255,0,0.2)';  // No confirmat or undefined
    })();

    const isBaixDuplicat = bundleJSON && caixa in bundleJSON ?
        bundleJSON[caixa]?.pestanya?.toLowerCase() !== 'tronc' :
        false;

    const isSwappable = lastPair && lastPair.caixa === caixa && lastPair.caixa !== selectedBox && selectedBox !== null;
    const isCanalla = (isPom && pomType?.toLowerCase() !== 'dos') || (isPom && isNaN(parseInt(castellersInfo?.[casteller]?.altura)));

    return (
        <div 
            className={`box ${selectedBox === caixa ? 'selected' : ''}`}
            style={{ 
                backgroundColor: assistenciaColor,
                border: `2px solid ${isSwappable ? 'lightblue' :
                        selectedBox === caixa ? 'orange' :
                        isBaixDuplicat ? 'darkred' :
                        'transparent'}`
            }}
            onClick={selectBox}
        >
            <div className="box-content">
                <div className="time-indicators">
                    {arribaTard && (
                        <div className="time-badge late">
                            {horaEntrada}
                        </div>
                    )}
                    {surtAviat && (
                        <div className="time-badge early">
                            {horaSortida}
                        </div>
                    )}
                </div>

                {isClone && <span className="clone-indicator">🔗</span>}
                
                <span className="casteller-name">
                    {displayName(casteller)}
                </span>

                {isCanalla && <span className="canalla-indicator">⛑️</span>}

                {!isCanalla && castellersInfo?.[casteller] && 'altura' in castellersInfo?.[casteller] && (
                    <div className={`altura-badge ${!isNaN(parseInt(castellersInfo?.[casteller]?.altura)) ? '' : 'invalid'}`}>
                        {!isNaN(parseInt(castellersInfo?.[casteller]?.altura)) ? 
                            castellersInfo[casteller].altura : 
                            '?'
                        }
                    </div>
                )}
            </div>

            {!isCanalla && (
                <div className="suma-altures">
                    {sumaAltures}
                </div>
            )}

            <style jsx>{`
                .box {
                    width: 65px;
                    height: 25px;
                    padding: 3px 0;
                    border-radius: 4px;
                    margin: 3px;
                    position: relative;
                    cursor: pointer;
                    transition: all 0.2s;
                }

                .box:hover {
                    background-color: #ddd;
                }

                .box.selected {
                    background-color: #f0f7ff;
                }

                .box-content {
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                    height: 100%;
                }

                .time-indicators {
                    display: flex;
                    flex-direction: column;
                }

                .time-badge {
                    background: white;
                    padding: 1px;
                    border-radius: 2px;
                    font-size: 7px;
                    color: red;
                }

                .clone-indicator {
                    font-size: 10px;
                }

                .casteller-name {
                    font-size: 11px;
                    color: black;
                }

                .canalla-indicator {
                    font-size: 9px;
                }

                .altura-badge {
                    background: white;
                    padding: 1px 2px;
                    border-radius: 2px;
                    font-size: 9px;
                }

                .altura-badge.invalid {
                    background: red;
                    color: #eee;
                }

                .suma-altures {
                    position: absolute;
                    top: -8px;
                    left: -8px;
                    background: purple;
                    padding: 1px 2px;
                    border-radius: 2px;
                    font-size: 9px;
                    color: white;
                }
            `}</style>
        </div>
    );
}

function areEqual(prevProps, nextProps) {
    const isSwappablePrev = prevProps.lastPair && prevProps.lastPair.caixa === prevProps.caixa && prevProps.lastPair.caixa !== prevProps.selectedBox && prevProps.selectedBox !== null;
    const isSwappableNext = nextProps.lastPair && nextProps.lastPair.caixa === nextProps.caixa && nextProps.lastPair.caixa !== nextProps.selectedBox && nextProps.selectedBox !== null;
    
    const isSelectedPrev = prevProps.selectedBox === prevProps.caixa;
    const isSelectedNext = nextProps.selectedBox === nextProps.caixa;

    const isPomPrev = prevProps.isPom;
    const isPomNext = nextProps.isPom;

    const pomTypePrev = prevProps.pomType;
    const pomTypeNext = nextProps.pomType;

    return (
        prevProps.empty === nextProps.empty && 
        prevProps.isClone === nextProps.isClone &&       
        isSelectedPrev === isSelectedNext &&
        isSwappablePrev === isSwappableNext &&
        isPomPrev === isPomNext &&
        pomTypePrev === pomTypeNext &&
        JSON.stringify(prevProps.bundleJSON) === JSON.stringify(nextProps.bundleJSON) &&
        JSON.stringify(prevProps.assistencia) === JSON.stringify(nextProps.assistencia) &&
        JSON.stringify(prevProps.hores) === JSON.stringify(nextProps.hores) &&
        prevProps.sumaAltures === nextProps.sumaAltures &&
        prevProps.caixa === nextProps.caixa &&
        prevProps.casteller === nextProps.casteller &&
        JSON.stringify(prevProps.castellersInfo) === JSON.stringify(nextProps.castellersInfo)
    );
}

export default React.memo(Box, areEqual);
